import { useOpQuery } from './useOpQuery';

export const useFeatureGate = (featureCode: string, orgId: number): boolean => {
  const { data: orgFeatures, isPending } = useOpQuery({
    apiEndpointName: 'listOrgFeatures',
    parameters: [Number(orgId)],
    select: (res) => res.json.data,
  });

  if (isPending || !orgFeatures) {
    return false;
  }

  const hasFeature = orgFeatures.some(({ code }) => {
    return Array.isArray(featureCode)
      ? featureCode.includes(code)
      : featureCode === code;
  });

  return hasFeature;
};
